import {createAsyncThunk} from '@reduxjs/toolkit'

import {TIMELINE_MOBILE_URL, TIMELINE_URL} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {LocationChangeHistoryParam, NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/**
 * 결제내역 페이지로 이동
 * - 기본 동작이 PC/Mobile 이 각각 다르게 동작합니다.
 * - PC 는 PC 결제내역을 새창(새탭)으로 엽니다.
 * - Mobile 은 Mobile 결제내역으로 PUSH 이동합니다.
 */
const navigateToTimeline = createAsyncThunk<
    NavigationResult,
    (NavigationTypeSelectableParam & LocationChangeHistoryParam) | void,
    ThunkApi
>('navigateTo/timeline', async (args) => {
    const {forceLocationChange = false, historyType = 'PUSH'} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile
    const url = isMobile ? TIMELINE_MOBILE_URL : TIMELINE_URL

    if (shouldChangeLocation) {
        changeBrowserLocation({
            url,
            type: historyType,
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    openNewTab({url})
})

export default navigateToTimeline
